import { StatInfo } from "../entities/entities";
import { EntityManager, Repository } from "aurelia-orm";
import { autoinject } from 'aurelia-dependency-injection';

@autoinject()
export class StatInfoService {
	repository: Repository;
	constructor(private entityManager: EntityManager) {
		this.repository = this.entityManager.getRepository(StatInfo);
	}	

	getNew(): any {
		return this.repository.getNewEntity();
	}
	
	getStatInfo(parentId:number, statInfoType:number) {
		return this.repository.find(`stat-info?parentId=${parentId}&statInfoType=${statInfoType}`);
	}

	getItemStatusInfoByFolderId(parentId: number, ownershipStatusCode:string) {
		return this.repository.find(`item-status-info?parentId=${parentId}&ownershipStatusCode=${ownershipStatusCode}`, true);
	}

	getDueStatusInfoByFolderId(parentId: number, ownershipStatusCode: string) {
		return this.repository.find(`due-status-info?parentId=${parentId}&ownershipStatusCode=${ownershipStatusCode}`, true);
	}

	getItemStatusInfo(ownershipStatusCode: string) {
		return this.repository.find(`item-status-info?ownershipStatusCode=${ownershipStatusCode}`, true);
	}

	async getDueStatusInfo(parameters) {
		return await this.repository.findPath(this.repository.getResource() + '/due-status-info', parameters, true);
	}

	async getTeamsTaskInfo(parameters) {
		return await this.repository.findPath(this.repository.getResource() + '/teams-task-info', parameters, true);
	}

	//getDueStatusInfo(ownershipStatusCode: string) {
	//	return this.repository.find(`due-status-info?ownershipStatusCode=${ownershipStatusCode}`, true);
	//}

	getMyStatInfo(statInfoType: number) {
		return this.repository.find(`my-stat-info?statInfoType=${statInfoType}`);
	}
}